// Definición de módulos (clave, nombre) y pasos del tour guiado por pantalla.
// Los selectores usan data-testid existentes; los pasos cuyo elemento no esté en pantalla se omiten.
export const MODULES = [
  ["dashboard", "Dashboard"], ["pos", "Punto de Venta"], ["checador", "Checador de Precios"], ["caja", "Mi Caja"], ["sales", "Historial de Ventas"],
  ["returns", "Devoluciones"], ["cotizaciones", "Cotizaciones"], ["cajas", "Cajas de Cajeros"], ["inventory", "Inventario"],
  ["promociones", "Promociones"], ["shopify", "Shopify"], ["batches", "Lotes y Caducidades"], ["purchases", "Compras"], ["customers", "Clientes"], ["bank", "Banco y Caja Fuerte"],
  ["gastos", "Gastos"], ["nomina", "Nómina"], ["finanzas", "Finanzas"], ["presupuestos", "Presupuestos"], ["reportes", "Reportes"], ["envios", "Envíos"],
  ["multiempresa", "Multiempresa"], ["whatsapp", "Ventas por WhatsApp"], ["tareas", "Tareas"], ["asistencia", "Checador de Asistencia"], ["users", "Usuarios"], ["settings", "Configuración"],
];

export const moduleFromPath = (path) => (path || "/").split("/")[1] || "dashboard";

const common = [
  { el: '[data-testid="branch-switcher"]', title: "Sucursal", text: "Si tienes varias sucursales, aquí cambias la que estás administrando." },
  { el: '[data-testid="terminal-chip"]', title: "Terminal", text: "Estación configurada en este equipo (impresora y báscula). Haz clic para cambiarla." },
  { el: '[data-testid="help-button"]', title: "Ayuda", text: "Desde este botón puedes ver el video del módulo o repetir este recorrido cuando quieras." },
];

export const TOURS = {
  dashboard: [
    { el: '[data-testid="nav-pos"]', title: "Menú principal", text: "Navega entre los módulos del sistema. Los que no uses se pueden ocultar desde Configuración." },
    ...common,
  ],
  pos: [
    { el: '[data-testid="pos-barcode-input"]', title: "Escanea o busca", text: "Pasa el código de barras o escribe el nombre/SKU. También lee códigos de notas guardadas para recuperarlas." },
    { el: '[data-testid="pos-save-note-btn"]', title: "Guardar nota", text: "Deja la venta en pausa con un código de barras para retomarla después." },
    { el: '[data-testid="pos-held-btn"]', title: "Notas guardadas", text: "Lista de ventas en pausa para recuperarlas." },
    { el: '[data-testid="pos-secondary-toolbar"]', title: "Herramientas", text: "Checador de precios, producto rápido, WhatsApp, pantalla de cliente, reimprimir última venta y bloquear la caja para cambio de turno." },
    { el: '[data-testid="pos-lock-btn"]', title: "Bloquear caja", text: "Bloquea la pantalla; otro cajero entra con su PIN sin perder la venta en curso." },
    { el: '[data-testid="pos-cart-list"]', title: "Venta actual", text: "Productos del ticket. Ajusta cantidades, quita renglones o consulta existencias en otras sucursales." },
    { el: '[data-testid="pos-charge-btn"]', title: "Cobrar", text: "Abre el cobro: efectivo, tarjeta, transferencia, crédito o pagos mixtos. Calcula el cambio automáticamente." },
    ...common,
  ],
  inventory: [
    { el: '[data-testid="product-add-btn"]', title: "Nuevo producto", text: "Da de alta productos con precios por nivel, variantes, lotes y caducidades." },
    { el: '[data-testid="product-search"]', title: "Buscar", text: "Filtra por nombre, código o categoría." },
    { el: '[data-testid="product-import-btn"]', title: "Importar", text: "Carga masiva desde Excel/CSV." },
    ...common,
  ],
  customers: [
    { el: '[data-testid^="history-"]', title: "Notas e historial", text: "Consulta las notas a crédito, abonos e historial de cada cliente." },
    { el: '[data-testid^="abono-"]', title: "Abonar", text: "Registra pagos a la deuda del cliente e imprime el comprobante." },
    ...common,
  ],
  cajas: [
    { el: '[data-testid="tab-cortes"]', title: "Revisión de cortes", text: "Cortes con diferencia pendientes de revisar por el administrador." },
    { el: '[data-testid="tab-turnos"]', title: "Bitácora de turnos", text: "Quién bloqueó, quién entró y cierres hechos por el administrador." },
    { el: '[data-testid^="admin-close-"]', title: "Cerrar caja ajena", text: "Cierra la caja de un cajero que se fue sin hacer su corte; queda constancia a tu nombre." },
    ...common,
  ],
  sales: [
    { el: '[data-testid="folio-search-input"]', title: "Buscar folio", text: "Encuentra cualquier venta por su número de ticket." },
    ...common,
  ],
  nomina: [
    { el: '[data-testid="tab-cut"]', title: "Corte de nómina", text: "Se paga por semana: elige la semana, revisa incidencias y paga desde el día configurado." },
    { el: '[data-testid="payroll-week-bar"]', title: "Semana a pagar", text: "Navega entre semanas; no se puede pagar dos veces la misma semana ni antes del día de pago." },
    ...common,
  ],
  reportes: [
    { el: '[data-testid="rep-tab-categorias"]', title: "Ventas por categoría", text: "Qué categorías y productos venden más en el periodo." },
    { el: '[data-testid="rep-tab-kardex"]', title: "Kardex", text: "Entradas, salidas y saldo de cualquier producto." },
    ...common,
  ],
  multiempresa: [
    { el: '[data-testid="tab-traspasos"]', title: "Traspasos", text: "Solicita o envía mercancía entre sucursales: surtir → en tránsito → confirmar recepción." },
    ...common,
  ],
  settings: [
    { el: '[data-testid="cfg-auto-lock-box"]', title: "Bloqueo automático", text: "Minutos de inactividad para bloquear la caja." },
    { el: '[data-testid="cfg-card-fee-box"]', title: "Comisión tarjeta", text: "Porcentaje que el banco cobra en pagos con tarjeta; se registra como gasto." },
    ...common,
  ],
};

export const tourFor = (module) => TOURS[module] || [
  { el: '[data-testid="nav-' + module + '"]', title: "Este módulo", text: "Aquí estás. Usa el video de ayuda para conocer el módulo a fondo." },
  ...common,
];
